import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TransactionType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useEditTransactionType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (transactionTypeData: Partial<TransactionType>): Promise<TransactionType> => {
      const response = await apiClient.transactionType.editTransactionType.mutation({ params: { id: transactionTypeData._id }, body: transactionTypeData });
      if (response.status !== 201) {
        throw new Error('Failed to edit transaction type');
      }
      return response.body.data as TransactionType;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transaction-types'] });
      toast.success('Transaction type edited successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error editing transaction type!');
    },
  });
};
